import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar      from './components/Navbar';
import HomePage    from './pages/HomePage';
import Aboutus     from './pages/Aboutus';
import Portfolio   from './pages/Portfolio';
import Contact     from './pages/Contact';
import ServiceDetails from './pages/ServiceDetails';
import Services from './pages/Services';

import Footer from './components/Footer'

export default function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/"                    element={<HomePage />} />
        <Route path="/about"               element={<Aboutus />} />
        <Route path="/services"            element={<Services />} />
        <Route path="/portfolio"           element={<Portfolio />} />
        <Route path="/contact"             element={<Contact />} />

        {/* Service detail — :serviceId matches 3d-signage, branding, etc. */}
        <Route path="/services/:serviceId" element={<ServiceDetails />} />

        {/* Catch-all → home */}
        <Route path="*"                    element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}